export enum NivelInteresse {
  SEM = 0,
  POUCO = 1,
  MEDIO = 2,
  MUITO = 3,
  NAO_INFORMADO = -1
}
